interface String
{
	/** Converts the first character of a string to upper case */
	capitalize(): string;

	/**  Each word or abbreviation in the middle of the phrase begins with a capital letter, with no intervening spaces or punctuation (ex: phoneNumber) */
	camelCase(exceptFirst?: boolean): string;

	/** Punctuation is removed and spaces are replaced by single hyphen */
	kebabCase(): string;

	/** Punctuation is removed and spaces are replaced by single underscore */
	snakeCase(): string;

	/** Converts the uppercase characters of a string to lowercase and lowercase characters to uppercase. */
	swapCase(): string;

	/** Only using capital letters for the main words */
	titleCase(): string;

	/** This method truncates a string at specified index and added three dots ... */
	trunc(index: number, useWordBoundary?: boolean): string;

	/** This method returns only the numeric part of the string */
	getNumericPart(): number;

	/** This method returns a new string with HTML tag */
	toHTML(): string;

	/** This method returns a new string without HTML tag */
	removeHTML(): string;

	/** This method returns a new string with \n in place of <br /> */
	replaceBrWithLineBreak(): string;

	/** This method returns a string into a float number */
	toFloat(): number;

	/** This method returns a string into a integer number */
	toInt(): number;

	toNumber(): number;

	/** This method returns a string replaced with RegExp */
	replaceOccurrence(regex: RegExp, replace: string, nthChild?: number): string;

	/** This method returns a string with lineBreak replaced with <br /> */
	replaceLineBreakWithHtml(): string;

	/** This method returns a string without spaces */
	removeSpaces(): string;

	/**return boolean*/
	toBoolean(): boolean

	isNotNullOrEmpty(): boolean;
	isNullOrEmpty(): boolean;

	/** This method convers a string to number[] array */
	toNumberArrayList(): number[];

	indexOfAll(value: string): number[];
	replaceAt(index: number, replacement: string): string;
}

interface StringConstructor
{
	/** Returns an empty string */
	empty: string;

	/** This method returns true if a string is not null and not empty
	 * @param stringToCheck The string to check */
	isNotNullOrEmpty(stringToCheck?: string | null): boolean;

	/** This method returns true if a string is null or empty
	 * @param stringToCheck The string to check */
	isNullOrEmpty(stringToCheck?: string | null): boolean;
}


String.empty = "";

String.isNotNullOrEmpty = function (stringToCheck: string): boolean
{
	return (stringToCheck != null && stringToCheck.length > 0);
}

String.isNullOrEmpty = function (stringToCheck?: string | null): boolean
{
	return (stringToCheck == null || stringToCheck.length == 0);
}

String.prototype.capitalize = function ()
{
	return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
}

String.prototype.camelCase = function (exceptFirst?: boolean)
{
	if (exceptFirst == null) exceptFirst = false;

	let words = this.split(" ");
	for (let word of words)
		word.capitalize();

	let stringToReturn = words.toString().replace(",", "");
	if (exceptFirst)
		stringToReturn = stringToReturn[0].toLowerCase() + stringToReturn.substr(1);

	return stringToReturn;
}

String.prototype.kebabCase = function (this)
{
	if (this.length == 0)
		return "";

	return this
		.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)!
		.map(x => x.toLowerCase())
		.join('-');
}

String.prototype.snakeCase = function (this)
{
	if (this.length == 0)
		return "";

	return this
		.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)!
		.map(x => x.toLowerCase())
		.join('_');
}

String.prototype.swapCase = function (this)
{
	var swapped = [];
	for (let i = 0; i < this.length; i++)
	{
		if (this != " ")
		{
			if (this[i] == this[i].toUpperCase())
				swapped.push(this[i].toLowerCase());
			else
				swapped.push(this[i].toUpperCase());
		}
	}
	return swapped.join("");
}

String.prototype.titleCase = function (this)
{
	return this.replace(/\w\S*/g, (txt) => { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() });
}

String.prototype.trunc = function (index: number, useWordBoundary?: boolean)
{
	if (useWordBoundary == null) useWordBoundary = true;

	if (this.length <= index) { return this.valueOf(); }
	var subString = this.substr(0, index - 1);
	return (useWordBoundary
		? subString.substr(0, subString.lastIndexOf(' '))
		: subString) + "&hellip;";
};

String.prototype.getNumericPart = function (this)
{
	let number = 0;
	if (this.length > 0)
		number = Number(this.match(/[\d\.]+/))

	return number;
}

String.prototype.toHTML = function (this)
{
	return this.replaceLineBreakWithHtml();
}

String.prototype.removeHTML = function (this)
{
	let tempDivElement = document.createElement("DIV");
	tempDivElement.innerHTML = this.valueOf();
	return tempDivElement.textContent || tempDivElement.innerText || "";
}

String.prototype.replaceBrWithLineBreak = function (this)
{
	let text = this.replace("<br />", "\n").replace("<br>", "\n").replace("<br/>", "\n");
	return text;
}

String.prototype.toFloat = function (this)
{
	if (this.valueOf() == "")
		return 0;
	else
		return parseFloat(this.valueOf());
}

String.prototype.toInt = function (this)
{
	if (this.valueOf() == "")
		return 0;
	else
		return parseInt(this.valueOf());
}

String.prototype.toNumber = function (this)
{
	if (this.valueOf() == "")
		return 0;
	else
		return Number(this.valueOf());
}

String.prototype.replaceOccurrence = function (regex: RegExp, replace: string, nthChild?: number)
{
	if (nthChild == null) nthChild = 1;
	let i = 0;
	return this.replace(regex, function (match)
	{
		i += 1;
		return (nthChild != null && i === nthChild) ? replace : match;
	});
}

String.prototype.replaceLineBreakWithHtml = function ()
{
	return this.replace(/(?:\r\n|\r|\n)/g, '<br />');
}

String.prototype.removeSpaces = function ()
{
	return this.replace(/ +?/g, '');
}

String.prototype.toBoolean = function ()
{
	return (this.toLowerCase() === "true");
}

String.prototype.isNotNullOrEmpty = function (this)
{
	return this != null && this != "";
}

String.prototype.isNullOrEmpty = function (this)
{
	return this == null || this == "";
}

String.prototype.toNumberArrayList = function (this): number[]
{
	return this.split(',').map(Number);
}

String.prototype.indexOfAll = function (value: string)
{
	let indices: number[] = [];
	for (let i = 0; i < this.length; i++)
		if (this[i] === value) indices.push(i);

	return indices;
}

String.prototype.replaceAt = function (index: number, replacement: string)
{
	return this.substring(0, index) + replacement + this.substring(index + replacement.length);
}